import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { ActionButton, Backdrop } from "../../components/Themed.js";
import { print } from "../../data/app/AppActions.js";
import { getEmployeeName } from "../../data/employee/EmployeeReducer";
import "./Confirmation.css";
import ConfirmationTick from "./ConfirmationTick.js";
import { t } from "../../locales";

class Confirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: null,
    };
  }

  getServiceNumberForAppointments(appointments = []) {
    if (!appointments?.length) {
      return '---'
    }
    
    const serviceNumbersArr = appointments?.reduce((acc, { id, service_number }) => {
      acc.push(service_number || id);

      return acc
    }, [])

    const result = serviceNumbersArr.join('\n')

    return result
  }

  componentDidMount() {
    const {
      appointments,
    } = this.props

    const serviceNumbers = this.getServiceNumberForAppointments(appointments)

    const timer = setTimeout(() => this.props.history.push("/"), 30000);
    this.props.print(serviceNumbers, this.props.printerMac);
    this.setState({ timer });
  }

  componentWillUnmount() {
    clearTimeout(this.state.timer);
  }

  renderConfirmationMessage(appointment, index, total) {
    const {
      serviceNumbersEnabled,
      variations,
      employees,
      clientEstimations,
    } = this.props;

    const employeeId = appointment.employee_id || null

    const serviceNumber = this.getServiceNumberForAppointments([appointment])

    let employeeName = getEmployeeName(employeeId, employees);
    if (!employeeName) {
      // might be waitlist appt with proposed staff
      const waitlistEmployeeId =
        clientEstimations &&
        clientEstimations[0] &&
        clientEstimations[0].chosen_time &&
        clientEstimations[0].chosen_time.employee_id;
      employeeName = getEmployeeName(waitlistEmployeeId, employees);
    }
    const variationNames =
      (
        (appointment &&
          appointment.slot_variations &&
          appointment.slot_variations.map((sv) => {
            const variation =
              variations && variations.find((v) => v.id === sv.variation_id);
            if (variation) {
              return variation.name;
            }

            return null;
          })) ||
        []
      ).filter((variationName) => !!variationName) || [];

    return (
      <div className="confirmation-message" key={appointment?.id}>
        {variationNames.map((variationName, i) => (
          <div key={i} className="confirmation-staff-service-name">
            {variationName}
          </div>
        ))}
        {employeeName && (
          <div className="confirmation-staff-service-name">{employeeName}</div>
        )}
        {serviceNumbersEnabled && (
          <div className="service-number-container">
            <div className="service-number-label">
              {t("confirmation.your_number_is")}
            </div>
            <div className="service-number">{serviceNumber}</div>
          </div>
        )}
        { !serviceNumbersEnabled && index < total && (<hr />) }
      </div>
    );
  }

  render() {
    const {
      appointments
    } = this.props

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="confirmation-title">
              <ConfirmationTick /> {t("confirmation.check_in_confirmed")}:
            </div>
            {appointments.map((appointment, index, arrRef) => this.renderConfirmationMessage(appointment, index, arrRef.length))}
            <div className="content">
              <div
                style={{
                  height: this.props.serviceNumbersEnabled ? "50px" : "200px",
                }}
              />
              <Link to="/">
                <ActionButton>{t("confirmation.button_done")}</ActionButton>
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    appointments: state.appointment.appointments,
    clientEstimations: state.appointment.clientEstimations,
    serviceProviderTerm: state.app.serviceProviderTerm,
    serviceNumbersEnabled:
      state.app.businessInfo.company.service_numbers_enabled,
    employees: state.employee.employees,
    printerMac: state.app.printerMac,
    variations: state.service.variations,
  };
}

export default withRouter(connect(mapStateToProps, { print })(Confirmation));
